<template>
	<div>
		<h1>
			403
			<template v-if="resource">
				{{ resource }}
			</template>
			Forbidden
		</h1>
	</div>
</template>

<script>
export default {
	page: {
		title: '403',
		meta: [{ name: 'description', content: '403' }]
	},
	props: {
		resource: {
			type: String,
			default: ''
		}
	}
}
</script>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
